import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { capitalize } from 'lodash';
import { useCoverageData } from 'src/components/screens/hooks';
import { CardIndividualProps } from './CardIndividual';
import CoverageDetailRow from './CoverageDetailRow';

const useStyle = makeStyles(() => ({
  container: {
    marginTop: '1rem',
  },
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  logo: { marginRight: 5, width: 27, height: 29 },
}));

const IndividualCoveragesResume = ({
  unit,
  coverageCatalogs,
  coverageCatalogResumes,
  packageOption,
  moneyType,
}: CardIndividualProps): JSX.Element => {
  const classes = useStyle();
  const { coveragesResume } = useCoverageData({
    coverageCatalogResumes,
    coverageCatalogs,
    unit,
    moneyType,
    packageOption,
  });

  return (
    <>
      <Grid container justifyContent="space-between">
        <Box display="flex">
          <img
            src="svg/shield_checked.svg"
            alt="shield_checked_icon"
            className={classes.logo}
            data-testid="icon-image"
          />
          <Typography className={classes.titleText} data-testid="title-text">
            Coberturas
          </Typography>
        </Box>
      </Grid>
      <Grid container className={classes.container}>
        <Box
          display="flex"
          flexDirection="column"
          style={{ gap: '1rem', marginBottom: '0.5rem', width: '100%' }}
        >
          {coveragesResume.map((coverage) => (
            <CoverageDetailRow
              key={coverage.code}
              data-testid={`coverages-${coverage.code}`}
              name={capitalize(coverage.name)}
              code={coverage.code}
              value={coverage.value}
            />
          ))}
        </Box>
      </Grid>
    </>
  );
};

export default IndividualCoveragesResume;
